import { render } from "./FavoriteBox.vue?vue&type=template&id=1925069c&scoped=true&ts=true"
import script from "./FavoriteBox.vue?vue&type=script&lang=ts"
export * from "./FavoriteBox.vue?vue&type=script&lang=ts"

import "./FavoriteBox.vue?vue&type=style&index=0&id=1925069c&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1925069c"]])

export default __exports__